<template>
  <div v-if="rubric" class="rubric">
    <!-- Meta Traits -->
    <template v-for="trait in rubric.meta_traits">
      <div :key="trait.id" class="mt-2">
        <span>
          {{ trait.name }}
          <span class="text-danger" v-if="trait.required">*</span>
        </span>
        <div v-if="trait.meta_trait_type == 1">
          <input @input="calculateScore()" type="text" v-model="trait.value" class="form-control" />
        </div>
        <div v-if="trait.meta_trait_type == 2">
          <textarea
            @input="calculateScore()"
            v-model="trait.value"
            class="form-control meta-text-area"
          ></textarea>
        </div>
        <div v-if="trait.meta_trait_type == 3">
          <select @change="calculateScore()" v-model="trait.value" class="form-control">
            <option value disabled>Select</option>
            <option v-for="o in trait.select_options" :key="o" :value="o">{{ o }}</option>
          </select>
        </div>
      </div>
    </template>
    <template v-for="(trait, i) in rubric.traits">
      <div :key="trait.id" class="mt-2" v-if="!trait.separator" v-show="!trait.hideSection">
        <!-- Numeric Trait -->
        <span :key="trait.name">{{ trait.name }}
          													<small v-if="trait.description" v-html="trait.description" class="form-text text-muted"></small>
  
        </span>
        <div class="trait-row">
          <template v-for="sp in trait.score_points">
            <button
              :id="`trait-${i}-sp-${sp.val}`"
              @click="select(trait, sp)"
              :class="{ active: isSelected(sp) }"
              :key="`trait-${i}-btn-${sp.val}`"
              class="score-point btn waves-effect waves-light"
            >
              {{ sp.val }}
              <div
                v-if="sp.freq != undefined"
                class="text-xs"
                :class="{
									[fdNotHighest(trait, sp) ? '_400' : '_600']: true,
									'text-extra-muted': sp.freq == 0
								}"
              >{{ sp.freq }}%</div>
              <i
                v-if="resMark(trait, sp) == 3"
                class="fas fa-check-double res-mark"
                v-tippy
                title="Agreed Score"
              />
              <i
                v-if="getExemplar(trait, sp)"
                class="fas fa-question exemplar-mark"
                v-tippy
                :title="
									`${getExemplar(trait, sp).length} ${
										getExemplar(trait, sp).length == 1 ? 'exemplar' : 'exemplars'
									}`
								"
                @click.stop="pickExemplar(trait, sp)"
              />
            </button>
            <b-popover
              v-if="hasDescriptor(trait, sp)"
              :target="`trait-${i}-sp-${sp.val}`"
              :key="`tt-${sp.val}`"
              placement="bottomright"
              :title="`${trait.name} - ${sp.val}`"
              :delay="{ show: 750, hide: 0 }"
              triggers="mouse hover"
            >
              <div v-html="getDescriptor(trait, sp)" class="mb-2"></div>
            </b-popover>
          </template>

          <button
            v-if="selectingTraits"
            :key="`trait-${i}-select`"
            @click="toggleExemplaryTrait(trait.id)"
            :class="{ active: pickedExemplaryTraits.includes(trait.id) }"
            class="ml-2 score-point btn waves-effect waves-light"
            style="flex: 0 1 50%; max-width: initial; min-width: 75px;"
          >
            Select as
            <br />exemplary
          </button>
        </div>
        <div v-if="trait.sp_condition_codes.length" class="trait-row">
          <template v-for="sp in trait.sp_condition_codes">
            <button
              :id="`trait-${i}-cc-${sp.val}`"
              @click="select(trait, sp)"
              :class="{ active: isSelected(sp) }"
              :key="`trait-${i}-btn-${sp.val}`"
              class="score-point btn waves-effect waves-light"
            >{{ sp.val }}</button>
            <b-popover
              v-if="hasCondDescriptor(trait, sp)"
              :target="`trait-${i}-cc-${sp.val}`"
              :key="`tt-${sp.val}`"
              placement="bottomright"
              :title="`${trait.name} - ${sp.val}`"
              :delay="{ show: 750, hide: 0 }"
              triggers="mouse hover"
            >
              <div v-html="getCondDescriptor(trait, sp)" class="mb-2"></div>
            </b-popover>
          </template>
        </div>
        <!-- Collect Evidence -->
        <div v-if="rubric.collect_evidence" class="trait-row">
          <input
            
            @input="calculateScore()"
            placeholder="Evidence Placeholder"
            type="text"
            v-model="trait.evidence"
            class="form-control"
          />
        </div>
      </div>
      <div :key="trait.id" class="mt-3 pb-1 d-flex flex-row" v-if="trait.separator">
        <span class="flex _600">{{ trait.name }}</span>
        <div class="justify-content-start align-self-center ml-2">
          <a @click="toggleCollapse(trait)">
            <i
              class="fas fa-lg fa-angle-down anim-rotate no-select"
              :class="{ 'rotate-90': trait.hideSection }"
            ></i>
          </a>
        </div>
      </div>
    </template>

    <div v-if="chooseRes">
      <hr />
      <span>Choose Score to Keep</span>
      <div class="trait-row">
        <button
          @click="selectResChoice(1)"
          :class="{ active: resChoice == 1 }"
          class="wide score-point btn waves-effect waves-light"
        >First</button>
        <button
          @click="selectResChoice(2)"
          :class="{ active: resChoice == 2 }"
          class="wide score-point btn waves-effect waves-light"
        >Second</button>
        <button
          @click="selectResChoice(3)"
          :class="{ active: resChoice == 3 }"
          class="wide score-point btn waves-effect waves-light"
        >Double Score</button>
      </div>
    </div>
  </div>
</template>

<style>
.v-select .dropdown-menu {
  overflow: hidden;
}
.v-select li > a {
  white-space: normal;
}
.meta-text-area {
  height: 90px;
}
.trait-row > button.wide {
  flex-basis: 33%;
  white-space: normal;
}
.res-mark {
  position: absolute;
  top: 3px;
  right: 4px;
  font-size: 0.8rem;
  opacity: 0.5;
}
.exemplar-mark {
  position: absolute;
  top: 3px;
  left: 4px;
  font-size: 0.8rem;
  opacity: 0.5;
}
.anim-rotate {
  transition: transform 0.1s ease-out;
}
.rotate-90 {
  transform: rotate(90deg);
}
</style>

<script>
import _ from "lodash";
import Utils from "@/services/Utils";

export default {
  name: "Rubric",
  props: [
    "outerRubric",
    "chooseRes",
    "reset",
    "initScore",
    "resFirstScore",
    "resSecondScore",
    "fd",
    "selectingTraits"
  ],
  data() {
    return {
      rubric: this.outerRubric,
      current_desc: null,
      trait_descriptors: {},
      trait_cond_descriptors: {},
      score: {},
      resChoice: 0,
      complete: false,

      pickedExemplaryTraits: []
    };
  },

  watch: {
    outerRubric: {
      handler: function(newVal) {
        this.rubric = _.cloneDeep(newVal);
        this.setup();
      },
      deep: true,
      immediate: true
    },
    //User of the rubric can modify this value to a random string, we'll watch it and reset everything if it changes
    reset() {
      this.setup();
    },

    pickedExemplaryTraits() {
      this.$emit("exemplaryTraits", this.pickedExemplaryTraits);
    },

    selectingTraits() {
      this.pickedExemplaryTraits = [];
    }
  },

  created() {
    this.$emit("update:score", this.initScore);
  },

  methods: {
    setup() {
      this.rubric.traits = _.sortBy(this.rubric.traits, "sequence");
      this.resChoice = 0;
      _.each(this.rubric.meta_traits, this.setupMetaTrait);
      _.each(this.rubric.traits, this.setupTrait);

      if (this.resFirstScore && this.resSecondScore) {
        let resAgreed = this.markResScores(
          this.resFirstScore,
          this.resSecondScore
        );
        this.fillScore(resAgreed);
      } else {
        this.fillScore(this.initScore);
      }

      this.calculateScore();
    },

    markResScores(f, s) {
      let agreementScore = { trait_scores: [] };
      _.each(this.rubric.traits, trait => {
        if (trait.separator) {
          return;
        }

        let fsp = _.find(f.trait_scores, { trait_id: trait.id });
        let ssp = _.find(s.trait_scores, { trait_id: trait.id });
        if (!(fsp && ssp)) {
          return;
        }
        let fs = fsp.condition == "" ? fsp.score : fsp.condition;
        let ss = ssp.condition == "" ? ssp.score : ssp.condition;

        if (fs == ss) {
          agreementScore.trait_scores.push(fsp);
        }

        _.each(trait.score_points, sp => {
          if (sp.val == fs) {
            sp.res_mark = 1;
          }
          if (sp.val == ss) {
            if (sp.res_mark) {
              sp.res_mark = 3;
            } else {
              sp.res_mark = 2;
            }
          }
        });

        _.each(trait.sp_condition_codes, sp => {
          if (sp.val == fs) {
            sp.res_mark = 1;
          }
          if (sp.val == ss) {
            if (sp.res_mark) {
              sp.res_mark = 3;
            } else {
              sp.res_mark = 2;
            }
          }
        });
      });

      return agreementScore;
    },

    fillScore(score) {
      if (!score) {
        if (this.rubric.prefill_score) {
          _.each(this.rubric.traits, trait => {
            if (trait.separator) {
              return;
            }

            this.select(trait, trait.score_points[0]);
          });
        }
        return;
      }

      this.resChoice = score.resolution_choice;

      _.each(score.trait_scores, tsp => {
        let trait = _.find(this.rubric.traits, { id: tsp.trait_id });
        if (trait) {
          trait.evidence = tsp.evidence;
          var activeSp;

          _.each(trait.score_points, sp => {
            if (tsp.score === sp.val || tsp.condition === sp.val) {
              sp.selected = true;
              activeSp = sp;
            } else {
              sp.selected = false;
            }
          });

          _.each(trait.sp_condition_codes, sp => {
            if (tsp.score === sp.val || tsp.condition === sp.val) {
              sp.selected = true;
              activeSp = sp;
            } else {
              sp.selected = false;
            }
          });
        }
      });
    },

    setupTrait(trait) {
      if (trait.separator) {
        return;
      }

      trait.evidence = "";
      let trait_fd = _.find(this.fd, { trait_id: trait.id });
      var max_freq = 0;

      //Numeric Traits
      var step = 1;
      if (trait.use_half_points) {
        step = 0.5;
      }
      var sps = [];
      var min = trait.min;
      var max = trait.max;

      var skip = trait.masked_score_points.map(function(mask) {
        return mask.mask_value;
      });

      if (this.rubric.reverse_score_points) {
        for (var i = max; i >= min; i -= step) {
          if (_.includes(skip, i)) {
            continue;
          }
          sps.push({
            val: i,
            selected: false
          });
        }
      } else {
        for (var i = min; i <= max; i += step) {
          if (_.includes(skip, i)) {
            continue;
          }
          sps.push({
            val: i,
            selected: false
          });
        }
      }

      //Fill fd data if we've got it
      if (trait_fd) {
        _.each(sps, sp => {
          let count = trait_fd.counts[sp.val];
          if (!count) {
            count = 0;
          }
          let freq = Math.round((count * 100) / trait_fd.total);
          max_freq = Math.max(max_freq, freq);
          sp.freq = freq;
        });
      }

      trait.score_points = sps;

      //Condition Codes
      var conditionCodes = [];
      trait.sp_condition_codes = [];
      _.each(trait.condition_codes, code => {
        var sp = {
          val: code.symbol,
          selected: false,
          condition_type: code.action
        };
        conditionCodes.push(sp);
      });

      //Fill fd data if we've got it
      if (trait_fd) {
        _.each(conditionCodes, sp => {
          let count = trait_fd.counts[sp.val];
          if (!count) {
            count = 0;
          }
          let freq = Math.round((count * 100) / trait_fd.total);
          max_freq = Math.max(max_freq, freq);
          sp.freq = freq;
        });
      }

      if (trait.inline_condition_codes) {
        trait.score_points = trait.score_points.concat(conditionCodes);
      } else {
        trait.sp_condition_codes = conditionCodes;
      }

      if (max_freq != 0) {
        trait.max_freq = max_freq;
      }
    },

    setupMetaTrait(trait) {
      if (trait.meta_trait_type == 3) {
        trait.select_options = trait.options.split("|");
      }
      trait.value = "";
    },

    select(trait, sp) {
      if (!sp.selected) {
        trait.evidence = "";
      }

      _.each(trait.score_points, sp => {
        sp.selected = false;
      });
      _.each(trait.sp_condition_codes, sp => {
        sp.selected = false;
      });
      trait.complete = true;
      sp.selected = true;

      this.calculateScore();
    },

    selectResChoice(choice) {
      this.resChoice = choice;

      this.calculateScore();
    },

    calculateScore() {
      this.isComplete();
      if (!this.complete) {
        this.$forceUpdate();
        this.$emit("update:score", null);
        return;
      }

      this.score = {
        response_id: this.response_id,
        qc_response_id: this.qc_response_id,
        trait_scores: [],
        meta_trait_scores: []
      };

      //Numeric Traits
      _.each(this.rubric.traits, trait => {
        if (trait.separator) {
          return;
        }

        var tsp = {
          trait_id: trait.id,
          score: -1,
          condition: "",
          evidence: trait.evidence
        };

        _.each(trait.score_points, sp => {
          if (sp.selected) {
            if (Utils.isNumeric(sp.val)) {
              tsp.score = parseFloat(sp.val);
            } else {
              tsp.condition = sp.val;
            }
            if (sp.condition_type == 2) {
              this.score.submit = "review";
            }
          }
        });

        _.each(trait.sp_condition_codes, sp => {
          if (sp.selected) {
            if (Utils.isNumeric(sp.val)) {
              tsp.score = parseFloat(sp.val);
            } else {
              tsp.condition = sp.val;
            }
            if (sp.condition_type == 2) {
              this.score.submit = "review";
            }
          }
        });

        this.score.trait_scores.push(tsp);
      });

      //Meta Traits
      _.each(this.rubric.meta_traits, mt => {
        var msp = {
          meta_trait_id: mt.id,
          value: mt.value
        };
        this.score.meta_trait_scores.push(msp);
      });

      this.score.resolution_choice = this.resChoice;

      this.$forceUpdate();
      this.$nextTick(() => {
        this.$emit("update:score", this.score);
      });
    },

    isComplete() {
      var scoreComplete = true,
        metaComplete = true,
        conditionComplete = false,
        spCodeComplete = true,
        resChoiceComplete = true;

      //Check all traits for completeness
      _.each(this.rubric.traits, trait => {
        if (trait.separator) {
          return;
        }

        var selected = false;
        _.each(trait.score_points, s => {
          if (s.selected) {
            selected = true;
            if (s.condition_type == 2) {
              conditionComplete = true;
            }
          }
        });
        _.each(trait.sp_condition_codes, s => {
          if (s.selected) {
            selected = true;
            if (s.condition_type == 2) {
              conditionComplete = true;
            }
          }
        });

        if (!selected) {
          scoreComplete = false;
        }
      });

      //TODO Check meta traits
      _.each(this.rubric.meta_traits, mt => {
        if (mt.required && mt.value == "") {
          metaComplete = false;
        }
      });

      if (this.chooseRes) {
        if (!this.resChoice) {
          resChoiceComplete = false;
        }
      }

      //TODO update to include other complete settings
      this.complete =
        resChoiceComplete &&
        ((scoreComplete && metaComplete) || conditionComplete);
      // (scoreComplete && metaComplete && spCodeComplete) ||

      this.$emit("update:complete", this.complete);
    },

    isSelected(sp) {
      return sp.selected;
    },

    getExemplar(trait, sp) {
      let obj = _.find(trait.score_point_descriptors, { val: sp.val });
      if (typeof sp.val == "string") {
        obj = _.find(trait.score_point_descriptors, { code: sp.val });
      }

      if (!obj || !obj.exemplars || obj.exemplars.length == 0) {
        return null;
      }
      return obj.exemplars;
    },

    getDescriptor(trait, sp) {
      if (typeof sp.val == "string") {
        return this.getCondDescriptor(trait, sp);
      }

      let obj = _.find(trait.score_point_descriptors, { val: sp.val });
      return obj && obj.desc;
    },

    hasDescriptor(trait, sp) {
      if (typeof sp.val == "string") {
        return this.hasCondDescriptor(trait, sp);
      }

      let obj = _.find(trait.score_point_descriptors, { val: sp.val });
      if (!obj) {
        return false;
      }
      return !(obj.desc == null || obj.desc == "");
    },

    getCondDescriptor(trait, sp) {
      let obj = _.find(trait.score_point_descriptors, { code: sp.val });
      return obj && obj.desc;
    },

    hasCondDescriptor(trait, sp) {
      let obj = _.find(trait.score_point_descriptors, { code: sp.val });
      if (!obj) {
        return false;
      }
      return !(obj.desc == null || obj.desc == "");
    },

    fdNotHighest(trait, sp) {
      if (!trait.max_freq || sp.freq == undefined) {
        return false;
      }

      return sp.freq < trait.max_freq;
    },

    resMark(trait, sp) {
      return sp.res_mark;
    },

    toggleCollapse(trait) {
      let inSection = false;
      _.each(this.rubric.traits, t => {
        if (t.id == trait.id) {
          this.$set(t, "hideSection", !t.hideSection);
          inSection = true;
        } else {
          if (t.separator) {
            inSection = false;
          } else if (inSection) {
            this.$set(t, "hideSection", !t.hideSection);
          }
        }
      });
    },

    pickExemplar(trait, sp) {
      this.$emit("exemplar", { trait: trait, sp: sp });
    },

    toggleExemplaryTrait(traitID) {
      let index = this.pickedExemplaryTraits.indexOf(traitID);
      if (index >= 0) {
        this.$delete(this.pickedExemplaryTraits, index);
      } else {
        this.pickedExemplaryTraits.push(traitID);
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Rubric.vue